export const isInstagramBrowser = (): boolean => {
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
  return ua.indexOf('Instagram') > -1;
};

export const isFacebookBrowser = (): boolean => {
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;
  return ua.indexOf('FBAN') > -1 || ua.indexOf('FBAV') > -1;
};

export const isInAppBrowser = (): boolean => {
  return isInstagramBrowser() || isFacebookBrowser();
};

export const getExternalBrowserUrl = (currentUrl: string): string => {
  if (isInstagramBrowser()) {
    // Instagram doesn't have a direct protocol, suggest Safari/Chrome
    return currentUrl;
  }
  if (isFacebookBrowser()) {
    // Facebook has a protocol to open in external browser
    return currentUrl;
  }
  return currentUrl;
};

export const getBrowserName = (): string => {
  if (isInstagramBrowser()) return 'Instagram';
  if (isFacebookBrowser()) return 'Facebook';
  return 'this app';
};
